import ChartingBaseController from './charting_base_controller';

export default class extends ChartingBaseController {
  static values = {
    actions: { type: Array, default: [] },
    debounce: { type: Number, default: 300 }
  };

  static targets = ['start', 'end'];

  #debounceTimer;

  execute() {
    clearTimeout(this.#debounceTimer);

    this.#debounceTimer = setTimeout(() => {
      const start = this.startTarget.value || null;
      const end = this.endTarget.value || null;
      const value = [start, end];
      const empty = !start && !end;

      this.applyActions(this.actionsValue, { value, remove: empty });
    }, this.debounceValue);
  }

  disconnect() {
    clearTimeout(this.#debounceTimer);
  }
}
